import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { PublicationConfiguration } from '@models/PublicationConfiguration';
import { PublicationConfigurationComponent } from "../publication-configuration/publication-configuration.component";
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { NewPublicationConfigurationDialogComponent } from './new-publication-configuration-dialog/new-publication-configuration-dialog.component';

@Component({
  selector: 'app-publication-configuration-list',
  imports: [
    CommonModule,
    PublicationConfigurationComponent,
    MatTabsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ],
  templateUrl: './publication-configuration-list.component.html',
  styleUrl: './publication-configuration-list.component.scss'
})
export class PublicationConfigurationListComponent implements OnInit {
  @Input() project!: ProjectConfiguration;
  @Input() formArray!: FormArray;
  @Input() parsingFormatGroup!: FormGroup;
  @Input() resetEvent!: EventEmitter<void>;

  selectedIndex: number = 0;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.project.publicationConfigurations.forEach((config) => {
      this.formArray.push(new FormControl<PublicationConfiguration>(config));
    });
  }

  add() {
    const dialogRef = this.dialog.open(NewPublicationConfigurationDialogComponent, {
      width: '400px',
      data: this.formArray
    });

    dialogRef.afterClosed().subscribe(newConfigId => {
      if (newConfigId) {
        const p = new PublicationConfiguration(newConfigId, this.project);
        this.formArray.push(this.fb.control<PublicationConfiguration>(p, { nonNullable: true }));
        this.selectedIndex = this.formArray.length - 1;
      }
    });
  }

  get formArrayControls(): FormControl<PublicationConfiguration>[] {
    return this.formArray.controls as FormControl<PublicationConfiguration>[];
  }

  get formArrayAsGroups(): FormGroup[] {
    // console.log(this.formArray.controls);
    return this.formArray.controls as FormGroup[];
  }

  deleteConfiguration(id: string) {
    this.formArray.removeAt(this.formArray.controls.findIndex((control) => {
      const config = control.value as PublicationConfiguration;
      return config.id === id;
    }));
  }


}
